<script>
// Importing Bar class from the vue-chartjs wrapper
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
import ChartDataLabels from "chartjs-plugin-datalabels";

// Exporting this so it can be used in other components
export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["options"],
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.addPlugin({
      id: "customScale",
      beforeLayout: (chart, options, c) => {
        let max = Number.MIN_VALUE;
        let min = Number.MAX_VALUE;
        let grace = options.grace || 0;

        chart.data.datasets.forEach((dataset) => {
          max = Math.max(max, Math.max(...dataset.data));
          min = Math.min(min, Math.min(...dataset.data));
        });

        if (typeof grace === "string" && grace.includes("%")) {
          grace = Number(grace.replace("%", "")) / 100;

          chart.options.scales.yAxes.forEach((axe) => {
            axe.ticks.suggestedMax = max + max * grace;
            axe.ticks.suggestedMin = min - min * grace;
          });
        } else if (typeof grace === "number") {
          chart.options.scales.yAxes.forEach((axe) => {
            axe.ticks.suggestedMax = max + grace;
            axe.ticks.suggestedMin = min - grace;
          });
        }
      },
    });
    // renderChart function renders the chart with the datacollection and options object.
    this.renderChart(this.chartData, this.options);
  },
};
</script>
